import type { BlogPost } from '../../../../../../../types';

export const shouldRenderCover = (coverMedia: BlogPost['coverMedia']) => {
  return coverMedia?.image?.url
    ? !!coverMedia.image
    : !!coverMedia?.video?.thumbnail;
};
